import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";

function SessionWarningModal({ open, seconds, onContinue, onLogout }) {
  const COLORS = {
    primary: "#193968",
    accent: "#cc9840",
    neutralLight: "#aeb9c7",
    neutralDark: "#5a7191",
  };

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1,
        },
      }}
    >
      <DialogTitle sx={{ color: COLORS.primary, fontWeight: 700 }}>
        Session Expiry Warning
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" sx={{ color: COLORS.neutralDark, mb: 2 }}>
          You have been inactive for a while. For security reasons, you will be
          logged out automatically.
        </Typography>

        <Box
          sx={{
            textAlign: "center",
            py: 1.5,
            borderRadius: 2,
            backgroundColor: COLORS.neutralLight,
          }}
        >
          <Typography
            variant="h6"
            sx={{ color: COLORS.primary, fontWeight: 700 }}
          >
            {seconds} seconds
          </Typography>
          <Typography variant="caption" sx={{ color: COLORS.primary }}>
            remaining
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onLogout}
          sx={{
            color: COLORS.neutralDark,
            fontWeight: 600,
          }}
        >
          Logout
        </Button>

        <Button
          onClick={onContinue}
          variant="contained"
          sx={{
            backgroundColor: COLORS.accent,
            color: "#ffffff",
            fontWeight: 600,
            "&:hover": {
              backgroundColor: "#b88936",
            },
          }}
        >
          Continue Session
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SessionWarningModal;
